import { render, staticRenderFns } from "./Cases.vue?vue&type=template&id=23d9d072&scoped=true&"
var script = {}
import style0 from "./Cases.vue?vue&type=style&index=0&id=23d9d072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9d072",
  null
  
)

export default component.exports